import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'
import { useMediaQuery } from '@hooks/use-media-query'
import { Description } from '@ui/sections/Description'

import {
  BlockWrapper,
  ContentWrapper,
  ImageTable,
  Subtitle,
  TextWrapper,
  Title,
  Wrapper,
  WrapperTitle,
} from './styles'

export function WhySection({
  title,
  subtitle,
  config,
  padding,
  tableSubtitleWidth = '90%',
  textTransform,
  hover = false,
  uplift = false,
}) {
  const isDesktop = useMediaQuery('(max-width: 768px)')
  const isMobile = useMediaQuery('(max-width: 350px)')

  return (
    <Wrapper className="why-section-wrapper">
      {(title || subtitle || padding) && (
        <Description
          padding={padding}
          title={title}
          subtitle={subtitle}
          textTransform={textTransform}
        />
      )}
      <ContentWrapper className="why-section-content-wrapper">
        {config.map(
          ({
            id,
            title: contentTitle,
            subtitle: contentSubTitle,
            mobileSubTitle,
            imagePath,
            imageHeight,
            imageWidth,
            alt,
            imageTitle,
          }) => (
            <BlockWrapper
              className="item"
              key={`${alt}_${id}`}
              hover={hover}
              uplift={uplift}
            >
              {isDesktop ? (
                <WrapperTitle className="title-wrapper">
                  <TextWrapper>
                    <ImageTable
                      height={imageHeight}
                      width={imageWidth}
                      className="image-wrapper"
                    >
                      <ImageWithPlaceholder
                        src={imagePath}
                        alt={alt}
                        width={imageHeight}
                        height={imageWidth}
                      />
                    </ImageTable>
                    <Title as="h3" className="table-title">
                      {contentTitle}
                    </Title>
                  </TextWrapper>
                  <Subtitle tableSubtitleWidth={tableSubtitleWidth}>
                    {isMobile && mobileSubTitle
                      ? mobileSubTitle
                      : contentSubTitle}
                  </Subtitle>
                </WrapperTitle>
              ) : (
                <>
                  <ImageTable
                    height={imageHeight}
                    width={imageWidth}
                    className="image-wrapper"
                  >
                    <ImageWithPlaceholder
                      src={imagePath}
                      alt={alt}
                      width={imageHeight}
                      height={imageWidth}
                      title={imageTitle}
                    />
                  </ImageTable>
                  <WrapperTitle className="title-wrapper">
                    <Title as="h3" className="table-title">
                      {contentTitle}
                    </Title>
                    <Subtitle tableSubtitleWidth={tableSubtitleWidth}>
                      {contentSubTitle}
                    </Subtitle>
                  </WrapperTitle>
                </>
              )}
            </BlockWrapper>
          )
        )}
      </ContentWrapper>
    </Wrapper>
  )
}
